var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoResourceGroupSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 78.34L11.1299 61.67L39.9999 45.01L68.8599 61.67L39.9999 78.34Z",
    fill: "url(#paint0_linear_1499_390884)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 68.3501L11.1201 51.6801L11.1301 18.3301L40.0001 34.9901V68.3501Z",
    fill: "url(#paint1_linear_1499_390884)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.88 51.68L40 68.35V34.99L68.87 18.33L68.88 51.68Z",
    fill: "url(#paint2_linear_1499_390884)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 34.9899L11.1299 18.3299L39.9999 1.65991L68.8699 18.3299L39.9999 34.9899Z",
    fill: "url(#paint3_linear_1499_390884)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.97 26.6699L54.64 10.1199L54.22 9.87988L25.54 26.4399L25.97 26.6699Z",
    fill: "#C6C6C6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 35.24L11.1299 18.57V18.33L11.3399 18.21L40.2099 34.88L39.9999 34.99V35.24Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.49 33.33L13.29 28.6L13.3 22.91L21.49 27.65V33.33Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1499_390884",
    x1: 18.3499,
    y1: 74.17,
    x2: 61.6499,
    y2: 49.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1499_390884",
    x1: 15.1601,
    y1: 43.3401,
    x2: 40.3101,
    y2: 43.3401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1499_390884",
    x1: 40,
    y1: 43.34,
    x2: 68.88,
    y2: 43.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1499_390884",
    x1: 18.3499,
    y1: 30.8299,
    x2: 61.6499,
    y2: 5.82991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResourceGroupSmall);
export default __webpack_public_path__ + "static/media/no-resource-group-small.ae749544f632f563955a80a1685cc66a.svg";
export { ForwardRef as ReactComponent };